/* global klaviyo */
/**
 *
 *  EventPage - events details (for Upcoming and Completed events)
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 05/07/2024.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dimensions } from "react-native";
import { useHistory, useParams, useLocation, Link } from "react-router-dom";
import moment from "moment-timezone";
import Modal from "react-modal";
import Slider from "react-slick";
import Carousel from "react-gallery-carousel";
import Lottie from "react-lottie";
import { Title, Meta } from "react-meta-elements";

import { useAppState } from "../../state";
import { useRegion } from "../../context/RegionProvider";
// import { useSignUpState } from "../../state/SignUpState";

// Components
import Button from "../Button/Button";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ScrollToTopOnMount from "../ScrollToTopOnMount/ScrollToTopOnMount";
// import PartnersScroller from "../Homepage/PartnersScroller/PartnersScroller";
import GoogleMaps from "../LocationPicker/GoogleMaps";
import GoogleMap from "../LocationPicker/GoogleMap/GoogleMap";
import TBKTooltip from "../TruBeTooltip/TruBeTooltip";
import BreadcrumbNav from "../BreadcrumbNav/BreadcrumbNav";
// import TrainerCard from "../Homepage/PartnersScroller/TrainerCard/TrainerCard";
import TitleWithSeparator from "../TitleWithSeparator/TitleWithSeparator";
// import UpcomingExperiencesSlider from "../LifestyleLP/UpcomingExperiencesSlider/UpcomingExperiencesSlider";
// import { EventCard } from "../LifestyleLP/LifestyleLP";
// import GatedEventCard  from "../LifestyleLP/LifestyleLP/GatedEventCard/GatedEventCard";
import { ReadMore } from "../TrainerProfilePage/TrainerProfilePage";
import TrainerRating from "../TrainerRating/TrainerRating";
import PartnerProductBadge from "../PartnerProductBadge/PartnerProductBadge";
import ShareModal from "../ShareModal/ShareModal";
import AppBanner from "../AppBanner/AppBanner";
import AppBannerUK from "../UKComponents/AppBanner/AppBanner";
// import { ElevatedClass } from "./ElevatedClass/ElevatedClass";

// Hooks
import useTheme from "../ThemeProvider/useTheme/useTheme";
// import useBodyScrollLock from "../../hooks/useBodyScrollLock/useBodyScrollLock";

// Icons
import CalendarIcon from "../../icons/CalendarTruBeIcon";
import CloseIcon from "../../icons/CloseIcon";
import ArrowLeftIcon from "../../icons/ArrowLeftIcon";
import ArrowRightIcon from "../../icons/ArrowRightIcon";
import CopyIcon from "../../icons/CopyIcon";
import BlockerIcon from "../../icons/BlockerIcon";
import CheckNiceIcon from "../../icons/CheckNiceIcon";
import MessagesIcon from "../../icons/MessagesIcon";
import MapMarkerIcon from "../../icons/MapMarkerIcon";
// import UploadIcon from "../../icons/UploadIcon";
import CaretDownIcon from "../../icons/CaretDownIcon";

// Utils
import { getTz } from "../../utils/date";
import { clientWidth, makeCancelable, getPartnerPictureUrl } from "../../utils";
import { modalStyles } from "../../constants";
import copy from "../../utils/copy";
import ics from "../../lib/icsFormatter/icsFormatter";

// Images
import Marker from "../LocationPicker/Marker/Marker";
import TruBeLogo from "./TruBeLogo";
import defaultPartnerPhoto from "../../images/generic-trainerphoto.svg";

import animationData from "../../lotties/loading-spinner";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const AUTOHIDE_TIME = 3000;
const MAX_CLASSES_TO_SHOW = 4;

const sliderResponsiveSettings = [
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 5000,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0",
    },
  },
];

const { height } = Dimensions.get("window");

const MediaBlock = ({ media, initialSlide }) => {
  const mediaContent = media;

  return (
    <Carousel
      // images={images}
      hasIndexBoard={false}
      hasMediaButton={false}
      hasSizeButton={false}
      hasThumbnails={false}
      index={initialSlide}
      leftIcon={
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1.5L6.5 0L0 6.5L6.5 13L8 11.5L3 6.5L8 1.5Z"
            fill="#CBCFD5"
          />
        </svg>
      }
      rightIcon={
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 1.5L1.5 0L8 6.5L1.5 13L0 11.5L5 6.5L0 1.5Z"
            fill="#CBCFD5"
          />
        </svg>
      }
      style={{ height: "100%", width: "100%" }}
      onIndexChange={({ curIndex, curIndexForDisplay }) => {}}
    >
      {mediaContent &&
        mediaContent.map((block) => (
          <figure className="_3iVQ0">
            <img className="_t1897" src={block.url} />
          </figure>
        ))}
    </Carousel>
  );
};

const SliderPrevArrow = ({ className, style, onClick }) => (
  <button className={className} style={style} onClick={onClick}>
    <ArrowLeftIcon className="tbk-inline" />
  </button>
);

const SliderNextArrow = ({ className, style, onClick }) => (
  <button className={className} style={style} onClick={onClick}>
    <ArrowRightIcon className="tbk-inline" />
  </button>
);

export default function EventPage() {
  const history = useHistory();
  const { EventId } = useParams();
  const location = useLocation();

  const { theme } = useTheme();
  const { region } = useRegion();

  const defaultCustomStyle = Object.assign(
    {
      content: {
        ...modalStyles.default.content,
        width: "358px",
      },
    },
    { overlay: { ...modalStyles.default.overlay, zIndex: 1060 } }
  );

  const {
    user,
    hasTriedToAutoLogin,
    eventSummary,
    partnerSummary,
    customerMembership,
    membershipItems,
    eventItems,
    upcomingEvents,
    customerPayment,
    futureEventsLoaded,
    searchPayment,
    loadEvent,
    joinEvent,
    leaveEvent,
    cancelEvent,
    loadCustomerMembership,
    loadUpcomingEvents,
    loadPartnerProfile,
    loadReviews,
    loadEventItems,
    getMembershipItems,
    clearCustomerMembership,
    error,
    isFetching,
    isEventFetching,
    isLoggedIn,
    customerMembershipLoaded,
    setPromoCode,
    clearUpcomingEventsLoaded,
    partnerLoaded,
    clearPartnerSummaryReceive,
    partnerReviews,
    partnerReviewsNumber,
  } = useAppState();

  // const { userPhoneCode, userPhoneNumber, setAuthState } = useSignUpState();

  // eslint-disable-next-line
  const [eventId, setEventId] = useState(null);
  const [mapsLoaded, setMapsLoaded] = useState(false);
  const [isCopyTooltipShow, setIsCopyTooltipShow] = useState(false);
  // eslint-disable-next-line
  const [isGalleryCarouselModalOpen, setIsGalleryCarouselModalOpen] =
    useState(null);
  const [galleryInitialSlide, setGalleryInitialSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const [isCancelRsvpModalOpen, setIsCancelRsvpModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [infoModalTitle, setInfoModalTitle] = useState("");
  const [infoModalMsg, setInfoModalMsg] = useState("");
  const [isShareModalOpen, setIsShareModalOpen] = useState();

  const [partnerMedia, setPartnerMedia] = useState([]);
  const [showMore, setShowMore] = useState(false);

  const sliderRef = useRef(null);
  const mapRef = React.useRef();
  const mapElementRef = React.useRef(null);
  const copyButtonRef = React.useRef(null);
  const hideCancelablePromiseRef = React.useRef(null);
  const infoModalResolveRef = useRef(null);

  const partnerProducts = partnerLoaded && partnerSummary.products;

  const _partnerMedia = partnerLoaded && partnerSummary.media;

  useEffect(() => {
    if (!hasTriedToAutoLogin) {
      return;
    }

    if (EventId) {
      setEventId(EventId);
      loadEvent(user && user.id, Number(EventId));

      if (user) {
        searchPayment(user.id, {
          type: "EVENT",
          attributes: {
            customerId: user.id,
            eventId: Number(EventId),
          },
        }).catch((err) => {});
      }
    } else {
      setEventId(null);
    }
  }, [user, EventId, hasTriedToAutoLogin]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!hasTriedToAutoLogin) {
      return;
    }

    // if (user) {
    //   checkTrialAvailable(user.id);
    // }

    getMembershipItems({ region: user ? user.region : region });

    loadEventItems({ region: user ? user.region : region });

    if (!futureEventsLoaded) {
      loadUpcomingEvents(
        user && user.id,
        "UPCOMING,STARTED,UPCOMING_FULL",
        { sort: "start", page: 0, size: 8 },
        user ? user.region : region,
        eventSummary && eventSummary.city
      );
    }

    if (user) {
      loadCustomerMembership(user.id).catch((err) => {
        console.log("Error loading customer membership: ", err);
      });
    }
  }, [user, futureEventsLoaded, hasTriedToAutoLogin]);

  useEffect(() => {
    if (eventSummary && upcomingEvents && upcomingEvents.length) {
      const futureEvents = upcomingEvents.filter(
        (v) =>
          v.location.name === eventSummary.location.name &&
          v.id !== eventSummary.id //&& v.partners && v.partners.length
      );
      setShowMore(futureEvents.length > MAX_CLASSES_TO_SHOW);
    }
  }, [eventSummary, upcomingEvents]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const autoBuy = queryParams.get("auto_buy");
    if (!customerMembership) {
      return;
    }
    if (autoBuy === "true") {
      // Trigger the auto-buy action
      //purchaseTicket(); // Function to handle ticket purchase
      if (customerMembership) {
        if (isSubscriptionExpired) {
          // Additional event purchase
          history.push(`/checkout?eventId=${eventSummary.id}`);
        } else {
          // Regular RSVP
          joinEvent(eventSummary.id, user.id, user.region)
            .then(() => {})
            .catch((err) => {
              if (err) {
                openInfoModal(err.message);
              }
            });
        }
      }
      // Optionally, you can clear the query parameter if needed
      history.replace(`/events/${eventSummary.id}`); // Replace the URL to remove the query string
    }
  }, [location, history, customerMembership]);

  // For logout
  useEffect(() => {
    if (!isLoggedIn) {
      clearCustomerMembership();
    }
    return () => clearCustomerMembership();
  }, [isLoggedIn]);

  useEffect(() => {
    if (sliderRef.current && eventSummary) {
      setTimeout(() => {
        // Check if it's present, because we might be on different state already
        sliderRef.current &&
          sliderRef.current.scrollTo({
            left: sliderRef.current.scrollWidth,
            behavior: "smooth",
          });
        // sliderRef.current.scrollLeft = sliderRef.current.scrollWidth;
      }, 1000);
    }
  }, [sliderRef.current, eventSummary]);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [eventSummary]);

  useEffect(() => {
    if (
      !eventSummary ||
      !(eventSummary.partners && eventSummary.partners.length)
    ) {
      return;
    }

    loadReviews(eventSummary.partners[0].id /*, 0*/);

    loadPartnerProfile(eventSummary.partners[0].id);

    return () => {
      clearPartnerSummaryReceive();
    };
  }, [eventSummary]);

  useEffect(() => {
    const newPartnerMedia = [];

    mapMedia(_partnerMedia).then((partnerMedia) => {
      console.log("newPartnerMedia", partnerMedia);

      if (partnerMedia) {
        newPartnerMedia.push(...partnerMedia);

        setPartnerMedia(
          newPartnerMedia.map((val, index) => ({ ...val, index }))
        );
      }
    });

    newPartnerMedia.unshift({
      type: "IMAGE",
      url: trainerPictureUrl ? trainerPictureUrl : defaultPartnerPhoto,
    });

    setPartnerMedia(newPartnerMedia.map((val, index) => ({ ...val, index })));
  }, [_partnerMedia]);

  // const { /*bottomBarHeight, */ refCallback, targetRef } =
  //   useBodyScrollLock(showAllGyms);

  const openGalleryCarouselModal = (index) => {
    setIsGalleryCarouselModalOpen(true);
    setGalleryInitialSlide(index);
  };

  const closeGalleryCarouselModal = () => {
    setIsGalleryCarouselModalOpen(false);
  };

  const openCancelRsvpModal = useCallback(() => {
    setIsCancelRsvpModalOpen(true);
  }, []);

  const closeCancelRsvpModal = useCallback(() => {
    setIsCancelRsvpModalOpen(false);
  }, []);

  const openShareModal = useCallback((e) => {
    setIsShareModalOpen(true);

    // Analytics.trackEvent(TRAINER_PAGE_CATEGORY, '', EVENT_SHARING_MENU);
  }, []);

  const closeShareModal = useCallback((e) => {
    setIsShareModalOpen(false);
  }, []);

  const openInfoModal = useCallback((msg, title = "Sorry") => {
    return new Promise((resolve, reject) => {
      infoModalResolveRef.current = resolve;

      setIsInfoModalOpen(true);
      setInfoModalTitle(title);
      setInfoModalMsg(msg);
    });
  }, []);

  const closeInfoModal = useCallback(() => {
    infoModalResolveRef.current();
    infoModalResolveRef.current = null;

    setIsInfoModalOpen(false);
  }, []);

  const slickInitialised = true;
  const isUserLoggedIn = !!(user && user.id);
  const trainerPictureUrl =
    partnerLoaded && getPartnerPictureUrl(partnerSummary);
  const handleBottomReached = useCallback(() => {}, []);
  const handleFullyOpen = useCallback(() => {}, []);
  var isSubscriptionExpired = false;

  if (customerMembership) {
    isSubscriptionExpired =
      customerMembership?.metadata.totalEvents ===
      customerMembership?.metadata.usedEvents;
  }

  const handleSlideSwipe = useCallback(
    (oldIndex, newIndex) => {
      if (autoPlay) {
        setAutoPlay(false);
      }
    },
    [autoPlay]
  );

  const eventPartners = eventSummary && eventSummary.partners;
  // const _partnerMedia = eventSummary && eventSummary.photos;

  const handleAddToCalendarClick = useCallback(
    (e) => {
      const title = `${eventSummary.name} event `;
      const place = `${eventSummary.location.address} (${eventSummary.location.detail})`;
      const begin = moment.utc(eventSummary.start).local();
      const end = moment.utc(eventSummary.finish).local();

      const eventDescription = eventSummary.description || "";

      ics.removeAllEvents();
      ics.addEvent(
        title,
        eventDescription,
        place,
        begin.toISOString(),
        end.toISOString()
      );

      ics.saveFile("Membership-Event");

      // if (isIosDevice()) {
      // @ts-ignore
      // } else {
      // ics?.download('calendar');
      // }
    },
    [eventSummary]
  );

  const handleCopyAddressToClipboard = useCallback(
    (e) => {
      if (eventSummary && copy(eventSummary.location.address)) {
        showCopyTooltip();

        // Analytics.trackEvent(SHARE_CATEGORY, '', target.tagName.toLocaleLowerCase() === 'button' ? EVENT_SHARE_LINK : EVENT_SHARE_CLIPBOARD);
      }
    },
    [eventSummary] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const showCopyTooltip = useCallback(() => {
    if (hideCancelablePromiseRef.current) {
      return;
    }

    // Auto hide afer 4 sec
    var hidePromise = new Promise((resolve, reject) => {
      setIsCopyTooltipShow(true);

      setTimeout(() => {
        resolve();
      }, AUTOHIDE_TIME);
    });

    hideCancelablePromiseRef.current = makeCancelable(hidePromise);

    return hideCancelablePromiseRef.current.promise.then(() => {
      hideCancelablePromiseRef.current = null;
      hideCopyTooltip();
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const hideCopyTooltip = useCallback(() => {
    if (hideCancelablePromiseRef.current) {
      hideCancelablePromiseRef.current.cancel();
      hideCancelablePromiseRef.current = null;
    }

    setIsCopyTooltipShow(false);
  }, []);

  const handleRsvpEvent = useCallback(
    (map) => {
      if (!eventSummary /* || !user*/) {
        return;
      }

      // Clear promo code from Special Offer box
      setPromoCode("");

      if (customerMembership) {
        if (eventSummary.tier !== "FREE_TIER") {
          // Gated event RSVP
          history.push(
            `/checkout?eventId=${eventSummary.id}&tier=${eventSummary.tier}`
          );
        } else if (isSubscriptionExpired) {
          // Additional event purchase
          history.push(`/checkout?eventId=${eventSummary.id}`);
        } else {
          // Regular event RSVP
          joinEvent(eventSummary.id, user.id, user.region)
            .then(() => {})
            .catch((err) => {
              if (err) {
                openInfoModal(err.message);
              }
            });
        }
      } else {
        if (eventSummary.tier !== "FREE_TIER") {
          history.push({
            pathname: isUserLoggedIn ? `/checkout` : `/become-a-member`,
            search: isUserLoggedIn
              ? `?membershipId=1`
              : `?return_to=${encodeURIComponent("/checkout?membershipId=1")}`,
            state: { from: location.pathname },
          });
        } else {
          history.push({
            pathname: isUserLoggedIn ? `/checkout` : `/become-a-member`,
            search: isUserLoggedIn
              ? `?eventId=${eventSummary.id}`
              : `?return_to=${encodeURIComponent(
                  `/checkout?eventId=${eventSummary.id}`
                )}`,
            state: { from: location.pathname },
          });
        }
      }
    },
    [history, user, eventSummary, customerMembership, isSubscriptionExpired]
  );

  const handleCancelRsvp = useCallback(
    (map) => {
      if (!eventSummary || !user) {
        return;
      }

      cancelEvent(customerPayment.id, user.id)
        .promise.then(() => {
          // Update customer membership
          if (customerMembership) {
            clearCustomerMembership();

            loadCustomerMembership(user.id); //.catch((err) => {
            //   console.log("Error loading customer membership: ", err);
            // });
          }

          closeCancelRsvpModal();
        })
        .catch((err) => {
          if (err) {
            openInfoModal(err.message);
          }
        });
    },
    [user, eventSummary, cancelEvent]
  );

  const handleGoogleMapsLoaded = useCallback((map) => {
    mapRef.current = map;

    setMapsLoaded(true);
  }, []);

  const handleOpenInMaps = useCallback(() => {
    if (!eventSummary) {
      return;
    }

    window.open(
      `https://maps.google.com/?q=${eventSummary.location.latitude},${eventSummary.location.longitude}`,
      "_blank" // <- This is what makes it open in a new window.
    );
  }, [eventSummary]);

  const handlePageLeave = useCallback(() => {
    setPromoCode("");
    clearUpcomingEventsLoaded();
  }, []);

  let formattedDate = formatEventDates(eventSummary, region);

  var soldOut = false;

  if (eventSummary) {
    soldOut = eventSummary.capacity === eventSummary.currentCapacity;
  }

  const membershipItem = getSingleTicketItem(membershipItems);

  const singleTicketPriceLabel = membershipItem
    ? `${membershipItem.price.symbol}${membershipItem.price.amount}`
    : "";

  const isGatedEvent = eventSummary && eventSummary.tier !== "FREE_TIER";

  const rsvpCtaLabel =
    isSubscriptionExpired && !isGatedEvent
      ? "Purchase"
      : customerMembership
      ? "RSVP"
      : `RSVP`; // for ${singleTicketPriceLabel}`;

  const isSingleTicket = !customerMembership;

  const mapMedia = async (partnerMedia) => {
    if (!partnerMedia) {
      return Promise.resolve([]);
    }
    return Promise.all(
      partnerMedia
        .map(async (v) => {
          if (v.type === "VIDEO") {
            return;
            const resp = await fetch(
              `https://www.youtube.com/oembed?url=${encodeURIComponent(
                v.url
              )}&format=json`
            );
            const json = await resp.json();

            const re = /<iframe.+src\=(?:\"|\')(.+?)(?:\"|\')(?:.+?)\>/i;
            const match = json.html.match(re);

            if (match) {
              v.url = match[1];
            }

            console.log("found", match);
          }

          return v;
        })
        .filter((v) => v && v.url)
    );
  };

  const renderClass = (eventData) => {
    const formattedDate = formatDate(eventData, region);
    return (
      <Link
        to={`/events/${eventData.id}`}
        className="tbk-relative tbk-mb-2 tbk-flex tbk-items-center tbk-overflow-hidden tbk-rounded-2xl tbk-bg-basic-white tbk-shadow-trube"
        onClick={() => window.scrollTo(0, 0)}
      >
        <img
          src={eventData.pastPhoto}
          alt="Class Image"
          className="tbk-hidden tbk-h-34 tbk-w-34 tbk-object-cover lg:tbk-block"
        />
        <div className="tbk-min-w-0 tbk-flex-grow tbk-py-1 tbk-pl-2 lg:tbk-py-2 lg:tbk-pl-4">
          <div className="tbk-text-main lg:tbk-text-h3-subtitle tbk-text-blue lg:tbk-mb-1">
            <span className="tbk-hidden lg:tbk-inline">
              {formattedDate && formattedDate[0]}
              {", "}
            </span>
            {formattedDate && formattedDate[1]},{" "}
            <span className="tbk-text-blue-grey">
              {formatTime(eventSummary, region)}
            </span>
          </div>
          <div className="tbk-text-h3-subtitle lg:tbk-text-title-medium tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap tbk-text-primary lg:tbk-mb-1">
            {eventData.name}
          </div>
          {eventData.partners && eventData.partners.length ? (
            <div className="tbk-text-main tbk-text-blue-grey">
              Led by {eventData.partners[0].firstName}
            </div>
          ) : null}
        </div>

        {eventData.joined ? (
          <CheckNiceIcon
            width={24}
            height={24}
            className="tbk-mr-2 tbk-rounded-full tbk-border tbk-border-basic-white tbk-bg-green tbk-text-basic-white"
          />
        ) : (
          <ArrowRightIcon className="tbk-mr-2 tbk-text-coral" />
        )}
        {eventData.capacity === eventData.currentCapacity ? (
          <div className="tbk-text-small tbk-absolute tbk-right-0 tbk-top-0 tbk-rounded-b-lg tbk-bg-primary tbk-px-1 tbk-text-basic-white lg:tbk-right-3">
            Sold Out
          </div>
        ) : null}
      </Link>
    );
  };

  const metaDescription =
    eventSummary && eventSummary.metaDescription
      ? eventSummary.metaDescription
      : `On-demand, in person, personal training in ${
          region === "US" ? "Los Angeles" : "London"
        }.`;

  const partnerFirstName = partnerLoaded && partnerSummary.firstName;
  const partnerFamilyName = partnerLoaded && partnerSummary.lastName;

  let futureEvents = upcomingEvents;

  if (eventSummary && upcomingEvents && upcomingEvents.length) {
    futureEvents = upcomingEvents.filter(
      (v) =>
        v.location.name === eventSummary.location.name &&
        v.id !== eventSummary.id // &&
      // v.partners && v.partners.length
    );
  }

  let moreClasses = [];

  if (upcomingEvents && upcomingEvents.length) {
    if (clientWidth() > theme.responsive.breakpoints.lg) {
      moreClasses = upcomingEvents
        .filter((v) => v.id !== (eventSummary && eventSummary.id))
        .slice(0, 16);
    } else {
      moreClasses = upcomingEvents
        .filter((v) => v.id !== (eventSummary && eventSummary.id))
        .slice(0, 8);
    }
  }

  return (
    <>
      <ScrollToTopOnMount />
      <Meta name="description" content={metaDescription} />
      <Header
        showRegionSelect={false}
        showLinks
        isFixed={clientWidth() >= theme.responsive.breakpoints.lg}
        // onViewCoachesNavLinkClick={() => clearAvailablePartnersLoaded()}
      />

      {/*{isGatedEvent ? (
        <ElevatedClass
          eventItem={
            eventItems &&
            eventItems.find((v) => v.metadata.tier === eventSummary.tier)
          }
          date={eventSummary && formattedDate[0]}
          time={formatTime(eventSummary, region, true)}
          soldOut={soldOut}
          confirmed={eventSummary && eventSummary.joined}
          partnerLogo={eventSummary && eventSummary.partnerLogo}
        />
      ) : (
        <div />
      )}*/}

      <div className="tbk-overflow-hidden tbk-bg-grey-light">
        <div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-8">
          <div
            ref={sliderRef}
            className="tb-slider tbk-mt-3 tbk-mb-3 tbk-flex tbk-flex-nowrap tbk-items-center"
          >
            <BreadcrumbNav className="tbk-bg-basic-white" to={"/lifestyle"}>
              Lifestyle collective
            </BreadcrumbNav>

            <ArrowRightIcon className="tbk-text-blue-grey-light" />

            <BreadcrumbNav
              className="tbk-bg-basic-white"
              to={`/events/${
                eventSummary && eventSummary.status === "COMPLETED"
                  ? "previous"
                  : "upcoming"
              }`}
            >
              {eventSummary && eventSummary.status === "COMPLETED"
                ? "Previous"
                : "Upcoming"}{" "}
              Classes
            </BreadcrumbNav>

            <ArrowRightIcon className="tbk-text-blue-grey-light" />

            <BreadcrumbNav>
              {eventSummary && !isEventFetching ? eventSummary.name : ""}
            </BreadcrumbNav>
          </div>
        </div>
      </div>

      <div className="tbk-flex tbk-flex-col tbk-items-center tbk-justify-center tbk-bg-grey-light tbk-pt-0 tbk-pb-4 lg:tbk-pt-4 lg:tbk-pb-7">
        <div className="tbk-container tbk-px-2 lg:tbk-px-8">
          <div className="tbk-flex tbk-flex-col tbk-flex-col-reverse lg:tbk-grid lg:tbk-grid-cols-event-layout lg:tbk-gap-4">
            <div className="tbk-mb-7_ tbk-mt-4_ lg:tbk-mt-0 lg:tbk-mb-0">
              <div className="tbk-flex_ tbk-mb-1 tbk-items-center lg:tbk-mb-2">
                <div className="tbk-mr-3_ tbk-min-w-0 tbk-grow">
                  {/*{eventSummary && eventSummary.city !== "ALL" ? (
                    <div className={`tbk-text-h3-subtitle tbk-mb-0.5 ${isFetching ? "tbk-text-blue-grey-light" : "tbk-text-grey"} lg:tbk-mb-1`}>
                      {isFetching ? "City" : eventSummary && adaptCityName(eventSummary.city)}
                    </div>
                  ) : null}*/}

                  {/*<div
                    className={`tbk-text-h3-subtitle tbk-mb-0.5 ${
                      isEventFetching
                        ? "tbk-text-blue-grey-light"
                        : "tbk-text-grey"
                    } lg:tbk-mb-1`}
                  >
                    {isEventFetching
                      ? "City"
                      : eventSummary && adaptCityName(eventSummary.city)}
                  </div>*/}
                  <div
                    className={`tbk-text-h3-subtitle lg:tbk-text-h2-black tbk-mb-1 tbk-hidden lg:tbk-block ${
                      isEventFetching
                        ? "tbk-text-blue-grey"
                        : "tbk-text-primary"
                    } lg:tbk-mb-2`}
                  >
                    {isEventFetching
                      ? "Loading ..."
                      : eventSummary && eventSummary.name}
                  </div>

                  <div
                    className={`${isGatedEvent ? "tbk-hidden " : ""}tbk-mb-4`}
                  >
                    {/*date*/}
                    {eventSummary && eventSummary.joined ? (
                      <div className="tbk-text-main tbk-hidden tbk-text-green lg:tbk-mt-5 lg:tbk-block">
                        You’re Confirmed
                      </div>
                    ) : soldOut && !isEventFetching ? (
                      <div className="tbk-text-h3-subtitle lg:tbk-text-h3-subtitle tbk-mt-1 tbk-uppercase tbk-text-coral">
                        Sold Out
                      </div>
                    ) : eventSummary && isSingleTicket && !isEventFetching ? (
                      <>
                        <div className="tbk-text-main tbk-text-primary lg:tbk-mt-1">
                          <span className="tbk-text-blue-grey">
                            Single Ticket
                          </span>
                          : {singleTicketPriceLabel}
                        </div>
                        <div className="tbk-text-main tbk-mb-1 tbk-text-primary">
                          <span className="tbk-text-blue-grey">
                            For Members
                          </span>
                          :{" "}
                          <span className="tbk-text-green">1 Class Credit</span>{" "}
                          (3 classes for {region === "US" ? "$" : "£"}
                          54)
                        </div>
                      </>
                    ) : null}
                  </div>

                  {eventSummary &&
                  eventSummary.joined &&
                  !isEventFetching &&
                  eventSummary.whatsappLink ? (
                    <div className="tbk-px-2_ tbk-mt-2 tbk-mb-2 tbk-gap-2 md:tbk-flex lg:tbk-mb-4 lg:tbk-block lg:tbk-px-0 xl:tbk-flex">
                      <a href={eventSummary.whatsappLink} target="_blank">
                        <Button
                          variant={"secondary"}
                          className="tbk-mb-2 tbk-w-full md:tbk-mb-0 md:tbk-w-72 lg:tbk-mb-2 xl:tbk-mb-0"
                          //onClick={() => {}}
                          startIcon={
                            <MessagesIcon className="tbk-text-green" />
                          }
                          endIcon={<ArrowRightIcon />}
                        >
                          Join the Class Chat
                        </Button>
                      </a>
                      <div className="tbk-text-secondary tbk-text-blue-grey">
                        Connect with your coach and fellow members before and
                        after class. Share tips, stay inspired, and build
                        community.
                      </div>
                    </div>
                  ) : null}

                  <div className="tbk--ml-2 tbk--mr-2 lg:tbk-ml-0 lg:tbk-mr-0 lg:tbk-pt-4 lg:tbk-pb-4">
                    <div className="tbk-bg-grey_ tbk-relative tbk-w-full tbk-pt-[59.2057761732852%] lg:tbk-bg-none">
                      {isEventFetching ? (
                        <div className="tbk-bottom-0_ tbk-absolute tbk-top-0 tbk-h-full tbk-w-full tbk-bg-blue-grey-light lg:tbk-rounded-2xl">
                          <TruBeLogo className="tbk-absolute tbk-top-1/2 tbk-left-1/2 tbk--translate-x-1/2 tbk--translate-y-1/2" />
                        </div>
                      ) : (
                        <img
                          className="tbk-absolute tbk-top-0 tbk-h-full tbk-w-full tbk-object-cover md:tbk-rounded-2xl"
                          src={
                            eventSummary && !isEventFetching
                              ? eventSummary.coverPhoto
                              : ""
                          }
                          alt={
                            eventSummary && !isEventFetching
                              ? eventSummary.name
                              : ""
                          }
                        />
                      )}
                    </div>
                  </div>

                  <div className="tbk-mt-4 tbk-mb-4">
                    {customerMembershipLoaded &&
                    eventSummary &&
                    eventSummary.joined ? (
                      <div className="tbk-w-full tbk-text-center lg:tbk-hidden">
                        <Button
                          // size={"md"}
                          variant="secondary"
                          className="tbk-w-72_ tbk-mb-2 tbk-w-full tbk-pl-5 tbk-pr-5"
                          startIcon={
                            <CalendarIcon className="tbk-text-green" />
                          }
                          endIcon={<ArrowRightIcon />}
                          onClick={handleAddToCalendarClick}
                        >
                          Add to Calendar
                        </Button>
                        <button
                          className="tbk-mb-4 tbk-inline-flex tbk-items-center tbk-text-blue-grey tbk-underline hover:tbk-text-grey-inactive lg:tbk-hidden"
                          onClick={openCancelRsvpModal}
                        >
                          Cancel RSVP
                          <ArrowRightIcon />
                        </button>
                      </div>
                    ) : null}

                    {isEventFetching
                      ? [1, 2, 3].map((v, index) => (
                          <div
                            key={index}
                            className={`${
                              index === 2
                                ? "tbk-mb-2 tbk-w-3/4"
                                : "tbk-mb-1 tbk-w-full"
                            } tbk-h-[15px] tbk-rounded-2xl tbk-bg-blue-grey-light`}
                          ></div>
                        ))
                      : eventSummary &&
                        eventSummary.description
                          .split(/\r\n|\n|\r/)
                          .map((line, index) => (
                            <p
                              key={index}
                              className="tbk-text-main tbk-mb-2 tbk-text-primary"
                            >
                              {line}
                            </p>
                          ))}
                  </div>

                  {/* soldout */}

                  <div className="tbk-text-small lg:tbk-text-main tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap tbk-text-grey">
                    {eventSummary && eventSummary.address}
                  </div>
                </div>

                {/*<Button
                  variant="secondary"
                  className="tbk-mb-4 tbk-w-full lg:tbk-w-86"
                  endIcon={<UploadIcon />}
                  onClick={openShareModal}
                >
                  Invite a Friend
                </Button>*/}

                {/* The Schedule */}
                {futureEvents &&
                futureEvents.length /* && futureEvents.length > 1*/ ? (
                  <div>
                    <TitleWithSeparator
                      textAlign="left"
                      className="tbk-mb-2 tbk-pt-4 lg:tbk-mb-3"
                      titleClass="tbk-text-center tbk-bg-grey-light tbk-text-blue-grey tbk-text-h3-subtitle lg:tbk-text-title-bold"
                      separatorClass="tbk-border-blue-grey-light"
                    >
                      The Schedule
                      {/*<br className="md:tbk-hidden" /> on Top Brands*/}
                    </TitleWithSeparator>

                    <div className="tbk-text-main lg:tbk-text-title-medium tbk-mt-2 tbk-mb-2 tbk-text-blue-grey lg:tbk-mt-4 lg:tbk-mb-4">
                      Classes in {eventSummary && eventSummary.location.name}
                    </div>

                    {futureEvents.length > MAX_CLASSES_TO_SHOW && showMore
                      ? futureEvents
                          .slice(0, MAX_CLASSES_TO_SHOW)
                          .map(renderClass)
                      : futureEvents.map(renderClass)}

                    {showMore ? (
                      <div className="tbk-mt-6 tbk-text-center">
                        <button
                          onClick={() => setShowMore(false)}
                          className="tbk-text-main tbk-inline-flex tbk-text-blue tbk-underline hover:tbk-text-blue-light"
                        >
                          View all Classes
                          <CaretDownIcon className="tbk-ml-0.5" />
                        </button>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
              {/* !The Schedule */}
            </div>

            <div className="tbk-overflow-hidden_ tbk-relative tbk--ml-2 tbk--mr-2 lg:tbk-ml-0 lg:tbk-mr-0 lg:tbk-h-auto">
              {/*img*/}
              <div
                className={`${
                  isGatedEvent ? "tbk-hidden lg:tbk-block " : ""
                }tbk-sticky tbk-top-8 tbk-rounded-2xl tbk-border-blue-grey-light tbk-p-2 lg:tbk-border lg:tbk-bg-basic-white`}
              >
                <div className="tbk-text-title-bold tbk-mb-2 tbk-hidden tbk-text-primary lg:tbk-mb-1 lg:tbk-block">
                  {eventSummary && eventSummary.location.name}
                </div>
                <div className="tbk-text-title-bold tbk-mb-2 tbk-text-primary lg:tbk-mb-1 lg:tbk-hidden">
                  {eventSummary && eventSummary.name}
                </div>

                <div
                  className={`tbk-text-h3-subtitle lg:tbk-text-title-medium lg:tbk-mb-4 ${
                    isEventFetching
                      ? "tbk-text-blue-grey-light"
                      : "tbk-text-primary md:tbk-text-grey"
                  }`}
                >
                  {isEventFetching ? "Date" : eventSummary && formattedDate[0]}
                  <div>
                    {isEventFetching
                      ? "Time"
                      : eventSummary && formattedDate[1]}
                  </div>
                </div>
                <div className="tbk-mb-2 tbk-hidden lg:tbk-block">
                  {/*<div className="tbk-mr-1 tbk-shrink-0 tbk-text-green">*/}
                  {/*  <MapMarkerIcon size={32} />*/}
                  {/*</div>*/}
                  {eventSummary && eventSummary.location.gymName ? (
                    <div className="tbk-text-main tbk-overflow-hidden_ tbk-text-ellipsis_ tbk-whitespace-nowrap tbk-text-primary">
                      {eventSummary.location.gymName} (
                    </div>
                  ) : null}
                  <div className="tbk-items-top tbk-text-main-linked tbk-flex tbk-text-blue-grey">
                    <MapMarkerIcon className="tbk-shrink-0" />

                    {eventSummary && eventSummary.location.address}
                    {eventSummary && eventSummary.location.gymName ? ")" : ""}
                  </div>
                </div>

                <div>
                  {customerMembershipLoaded &&
                  eventSummary &&
                  eventSummary.joined ? (
                    <div className="tbk-hidden tbk-w-full tbk-text-center lg:tbk-inline-block">
                      <Button
                        // size={"md"}
                        variant="secondary"
                        className="tbk-w-72_ tbk-mb-2 tbk-w-full tbk-pl-5 tbk-pr-5"
                        startIcon={<CalendarIcon className="tbk-text-green" />}
                        endIcon={<ArrowRightIcon />}
                        onClick={handleAddToCalendarClick}
                      >
                        Add to Calendar
                      </Button>
                      <button
                        className="tbk-hidden tbk-items-center tbk-text-blue-grey tbk-underline hover:tbk-text-grey-inactive lg:tbk-inline-flex"
                        onClick={openCancelRsvpModal}
                      >
                        Cancel RSVP
                        <ArrowRightIcon />
                      </button>
                    </div>
                  ) : (customerMembershipLoaded || !user) &&
                    eventSummary &&
                    eventSummary.status !== "COMPLETED" &&
                    // eventSummary.status !== "UPCOMING_FULL" &&
                    eventSummary.status !== "STARTED" &&
                    !soldOut ? (
                    <div className="">
                      <Button
                        // size={"md"}
                        className="tbk-w-72_ tbk-hidden tbk-w-full tbk-pl-5 tbk-pr-5 lg:tbk-mt-0 lg:tbk-mb-0 lg:tbk-block"
                        endIcon={<ArrowRightIcon className="tbk-ml-0.5" />}
                        showLoader={isFetching}
                        onClick={handleRsvpEvent}
                      >
                        {rsvpCtaLabel}
                      </Button>
                    </div>
                  ) : soldOut && !isEventFetching ? (
                    <div className="">
                      <Button
                        disabled
                        // size={"md"}
                        className="tbk-w-72_ tbk-hidden tbk-w-full tbk-pl-5 tbk-pr-5 lg:tbk-mt-0 lg:tbk-mb-0 lg:tbk-block"
                        // endIcon={<ArrowRightIcon className="tbk-ml-0.5" />}
                      >
                        SOLD OUT
                      </Button>
                    </div>
                  ) : isEventFetching ? (
                    <div className="">
                      <Button
                        // size={"md"}
                        className="tbk-w-72_ tbk-hidden tbk-w-full tbk-pl-5 tbk-pr-5 lg:tbk-mt-0 lg:tbk-mb-0 lg:tbk-block"
                        disabled
                      >
                        RSVP
                      </Button>
                    </div>
                  ) : null}
                </div>
              </div>

              {/* whatsapp link */}
            </div>
          </div>

          {eventSummary && eventSummary.joined && false ? (
            <div className="tbk-mt-2 tbk-mb-2 lg:tbk-hidden">
              <Button
                // size={"md"}
                variant="secondary"
                className="tbk-w-full tbk-pl-5 tbk-pr-5"
                startIcon={<CalendarIcon className="tbk-text-green" />}
                endIcon={<ArrowRightIcon />}
                onClick={handleAddToCalendarClick}
              >
                Add to Calendar
              </Button>
              {/*<p className="tbk-text-main tbk-text-primary">
                {eventSummary && eventSummary.description}
              </p>*/}
            </div>
          ) : null}
        </div>
      </div>

      {/*<div className="tbk-flex tbk-flex-col tbk-items-center tbk-justify-center tbk-pt-0 tbk-pb-4 lg:tbk-pt-4 lg:tbk-pb-7">
        <div className="tbk-container tbk-px-2 lg:tbk-px-8"></div>
      </div>*/}

      {partnerLoaded && partnerSummary ? (
        <div className="lg:tbk-bg-basic-white_ tbk-relative tbk-overflow-hidden tbk-bg-grey-light tbk-pt-4 lg:tbk-pt-5">
          <div className="tbk-container tbk-relative tbk-mx-auto tbk-px-2 xl:tbk-px-8">
            <TitleWithSeparator
              textAlign="left"
              className="tbk-mb-2 md:tbk-mb-3"
              titleClass="tbk-text-center tbk-bg-grey-light tbk-text-blue-grey tbk-text-h3-subtitle lg:tbk-text-title-bold"
              separatorClass="tbk-border-blue-grey-light"
            >
              Curated by {partnerSummary && partnerSummary.firstName}
            </TitleWithSeparator>

            <div className="xl:tbk-px-0_ tbk-flex tbk-flex-col-reverse lg:tbk-grid lg:tbk-grid-cols-event-layout lg:tbk-gap-34">
              <div>
                <h2 className="tbk-text-title-bold md:tbk-text-h2-black tbk-mt-4 tbk-mb-1 tbk-text-primary lg:tbk-mt-0 lg:!tbk-leading-tight">
                  {partnerSummary.firstName} {partnerSummary.lastName}
                </h2>

                {partnerLoaded && partnerReviewsNumber ? (
                  <TrainerRating
                    className="tbk-text-main tbk-mb-1 tbk-flex md:tbk-justify-start lg:tbk-mr-5"
                    averageRatingClassName="tbk-text-h3-subtitle tbk-text-blue-grey"
                    numberOfSessionsClassName="tb-link-like tbk-text-small md:tbk-text-main tbk-text-blue-grey tbk-underline"
                    partner={{
                      ...partnerSummary,
                      partnerRatingRecap: {
                        average: partnerSummary.rating,
                        //numberOfRatings: partnerReviewsNumber,
                      },
                    }}
                    // onClick={openReviewsModal}
                  />
                ) : null}

                <ul className="tb-slider tb-disciplines-skills-list tbk-flex tbk-flex-nowrap lg:tbk-flex-wrap">
                  {partnerProducts &&
                    partnerProducts.map((val) => (
                      <PartnerProductBadge
                        key={val.id}
                        className="tbk-mr-2 tbk-mb-2"
                        iconClassName="tbk-mr-0.5"
                        labelClassName="tbk-text-secondary"
                        activeCn="tbk-text-primary"
                        inactiveCn="tbk-text-primary"
                        product={val}
                        border={false}
                      />
                    ))}
                  <li className="tb-disciplines-skills-br" />
                </ul>

                <div className="tbk-mb-4 lg:tbk-mb-0">
                  <ReadMore
                    text={partnerLoaded ? partnerSummary.biography : ""}
                    gradientCn="tbk-to-grey-light"
                  />
                </div>
              </div>

              <div className="tbk-rounded-2xl_ tbk-relative tbk--ml-2 tbk--mr-2 tbk-overflow-hidden lg:tbk-h-auto lg:tbk-bg-none">
                <div
                  className={`media-slider no-gradient tbk-h-92 md:tbk-h-[470px] ${
                    !partnerMedia || partnerMedia.length <= 1 ? "no-media" : ""
                  } ${
                    true ? "tbk-justify-center" : ""
                  } lg:tbk-w-108_ tbk-relative tbk-flex tbk-h-full tbk-w-full tbk-flex-col tbk-overflow-hidden lg:tbk-m-0 lg:tbk-h-108 lg:tbk-rounded-2xl`}
                >
                  {slickInitialised && partnerMedia ? (
                    <Slider
                      className="coach-media-carousel"
                      dots={true}
                      dotsClass={"slick-dots"}
                      arrows={clientWidth() > theme.responsive.breakpoints.lg}
                      autoplay={autoPlay}
                      autoplaySpeed={4000}
                      pauseOnFocus
                      pauseOnDotsHover
                      pauseOnHover
                      infinite={true}
                      speed={500}
                      slidesToShow={1}
                      slidesToScroll={1}
                      initialSlide={0}
                      responsive={sliderResponsiveSettings}
                      nextArrow={<SliderNextArrow className="" />}
                      prevArrow={<SliderPrevArrow className="" />}
                      onSwipe={handleSlideSwipe}
                    >
                      {partnerMedia.map((val, index) => (
                        <div
                          id={`slide-${index}`}
                          className="slide partner-review-item _tbk-pl-2.5 _tbk-pr-2.5"
                          key={index}
                          onClick={() => openGalleryCarouselModal(index)}
                        >
                          <div className="content slide-bg tbk-h-full tbk-w-full">
                            <div
                              className="tb-image-container tbk-relative tbk-h-full tbk-overflow-hidden tbk-pt-100 lg:tbk-pt-full"
                              style={
                                {
                                  // paddingTop: "100%",
                                }
                              }
                            >
                              <img
                                className="tbk-absolute tbk-top-0 tbk-h-full tbk-w-full tbk-object-cover lg:tbk-rounded-2xl"
                                itemProp="image"
                                src={val.url}
                                alt={`Past photo for ${val.name} event`}
                              />
                            </div>
                          </div>
                          {/*{index !== partnerReviews.length - 1 ? <hr /> : null}*/}
                        </div>
                      ))}
                    </Slider>
                  ) : partnerMedia && partnerMedia.length ? (
                    <div
                      className="tb-image-container tbk-relative tbk-overflow-hidden tbk-pt-100 lg:tbk-pt-full"
                      style={
                        {
                          // paddingTop: "100%",
                        }
                      }
                    >
                      <img
                        className="tbk-absolute tbk-top-0 tbk-h-full tbk-w-full tbk-object-cover lg:tbk-rounded-2xl"
                        itemProp="image"
                        src={partnerMedia[0].url}
                        alt={`Past photo for ${
                          eventSummary && eventSummary.name
                        } event`}
                      />
                    </div>
                  ) : (
                    !eventSummary && (
                      <div className="tbk-py-5 sm:tbk-mt-[10px]">
                        <Lottie
                          options={defaultOptions}
                          height={
                            clientWidth() < theme.responsive.breakpoints.sm
                              ? 116
                              : 112
                          }
                          width={
                            clientWidth() < theme.responsive.breakpoints.sm
                              ? 116
                              : 112
                          }
                        />
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/*false && eventPartners && eventPartners.length ? (
        <div className="tbk-relative tbk-bg-basic-white tbk-pt-2 tbk-pb-4 lg:tbk-pt-0 lg:tbk-pb-0">
          <div className="tbk-container tbk-z-1 tbk-mx-auto lg:tbk-px-7 lg:tbk-pb-9">
            <div className="tbk-relative tbk-mb-2">
              <h3 className="tbk-text-h3-subtitle lg:tbk-text-title-bold tbk-inline-block tbk-bg-basic-white tbk-px-2 tbk-text-center tbk-text-blue-grey">
                Curated by
              </h3>
              <hr className="tbk-mb-0 tbk--mt-2 tbk-border-blue-grey-light" />
            </div>

            <div className="tbk-h-68_ tbk-mb-4_ lg:tbk-mb-2">
              {eventSummary &&
              eventSummary.status === "COMPLETED" &&
              eventPartners &&
              eventPartners.length ? (
                <PartnersScroller
                  partners={eventPartners}
                  renderPartner={({
                    info: partnerInfo,
                    index,
                    contentScrollerApi,
                    onCardVisibleChange,
                  }) => (
                    <Link to={`/partners/${partnerInfo.id}`}>
                      <TrainerCard
                        trainer={partnerInfo}
                        key={partnerInfo.id}
                        itemKey={index}
                        contentScrollerApi={contentScrollerApi}
                        onCardVisibleChange={onCardVisibleChange}
                        // onCardClick={handleCardClick}
                      />
                    </Link>
                  )}
                />
              ) : null}

              {eventSummary &&
              eventSummary.status !== "COMPLETED" &&
              eventPartners &&
              eventPartners.length ? (
                <PartnersScroller
                  partners={eventPartners}
                  renderPartner={({
                    info: partnerInfo,
                    index,
                    contentScrollerApi,
                    onCardVisibleChange,
                  }) => (
                    <TrainerCard
                      trainer={partnerInfo}
                      key={partnerInfo.id}
                      itemKey={index}
                      contentScrollerApi={contentScrollerApi}
                      onCardVisibleChange={onCardVisibleChange}
                      // onCardClick={handleCardClick}
                    />
                  )}
                />
              ) : null}
            </div>
          </div>
        </div>
      ) : null*/}

      {/*<div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-8">
        {_partnerMedia && _partnerMedia.length ? (
          <hr className="tbk-border-blue-grey-light" />
        ) : (
          <div className="tbk-text-center_ tbk-relative tbk-mb-2">
            <h3 className="tbk-text-h3-subtitle lg:tbk-text-title-bold tbk-inline-block tbk-bg-basic-white tbk-px-2 tbk-text-center tbk-text-blue-grey lg:tbk-hidden">
              Location
            </h3>
            <hr className="lg:tbk-mt-[15px]_ tbk-mb-0 tbk--mt-2 tbk-border-blue-grey-light" />
          </div>
        )}
      </div>*/}

      {/*<div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-8">
        <div className="tbk-text-center_ tbk-relative tbk-mb-2">
          <h3 className="lg:tbk-hidden tbk-text-h3-subtitle lg:tbk-text-title-bold tbk-inline-block tbk-bg-basic-white tbk-px-2 tbk-text-center tbk-text-blue-grey">
            Location
          </h3>
          <hr className="tbk-mb-0 tbk--mt-2 lg:tbk-mt-[15px]_ tbk-border-blue-grey-light" />
        </div>
      </div>*/}

      <div className="tbk-pb-7_ tbk-flex tbk-hidden tbk-flex-col tbk-items-center tbk-justify-center tbk-pt-4 tbk-pb-4 lg:tbk-pt-7 lg:tbk-pb-7">
        <div className="tbk-container tbk-px-2 lg:tbk-px-8">
          <TitleWithSeparator
            textAlign="center"
            className="tbk-mb-3"
            titleClass="tbk-text-center tbk-bg-basic-white tbk-text-blue-grey tbk-text-h3-subtitle lg:tbk-text-title-bold"
            separatorClass="tbk-border-blue-grey-light"
          >
            The Venue
          </TitleWithSeparator>
          <div className={`tbk-grid tbk-gap-4 lg:tbk-grid-cols-2`}>
            <div
              className={`tbk-min-w-0 tbk-rounded-b-2xl tbk-bg-grey-light${
                _partnerMedia && _partnerMedia.length ? "" : " tbk--order-1"
              }`}
            >
              <GoogleMaps
                mapElement={mapElementRef}
                onLoaded={handleGoogleMapsLoaded}
              >
                <div style={{ height: `${272}px` }}>
                  <div
                    ref={mapElementRef}
                    className="tbk-h-full tbk-rounded-lg"
                  >
                    {mapsLoaded && eventSummary ? (
                      <GoogleMap
                        defaultZoom={10}
                        defaultCenter={{
                          lat: eventSummary.location.latitude,
                          lng: eventSummary.location.longitude,
                        }}
                        defaultOptions={{
                          disableDefaultUI: true,
                          // styles: [{
                          //   featureType: 'all',
                          //   elementType: 'labels',
                          //   stylers: [{
                          //     visibility: 'off'
                          //   }]
                          // }]
                        }}
                      >
                        <Marker
                          position={{
                            lat: eventSummary.location.latitude,
                            lng: eventSummary.location.longitude,
                          }}
                        />
                      </GoogleMap>
                    ) : null}
                  </div>
                </div>
              </GoogleMaps>

              <div className="tbk-p-2">
                <div className="tbk-text-h3-subtitle tbk-mb-1 tbk-text-primary">
                  Address:
                </div>
                <div className="tbk-mb-2">
                  {/*<div className="tbk-mr-1 tbk-shrink-0 tbk-text-green">*/}
                  {/*  <MapMarkerIcon size={32} />*/}
                  {/*</div>*/}
                  {eventSummary && eventSummary.location.gymName ? (
                    <div className="tbk-text-main tbk-overflow-hidden_ tbk-text-ellipsis_ tbk-whitespace-nowrap tbk-text-primary">
                      {eventSummary.location.gymName} (
                    </div>
                  ) : null}
                  <div className="tbk-text-main tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap tbk-text-primary">
                    {eventSummary && eventSummary.location.address}
                    {eventSummary && eventSummary.location.gymName ? ")" : ""}
                  </div>
                </div>

                {/*<div className="tbk-text-small tbk-mb-0.5 tbk-text-primary">*/}
                {/*  Address details:*/}
                {/*</div>*/}
                {/*<div className="tbk-mb-2 tbk-flex tbk-items-center tbk-rounded-lg tbk-border tbk-border-blue-grey-light tbk-bg-grey-light tbk-py-1 tbk-px-2">*/}
                {/*  <div*/}
                {/*    className={`tbk-text-main tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap ${*/}
                {/*      eventSummary && eventSummary.location.detail*/}
                {/*        ? "tbk-text-primary"*/}
                {/*        : " tbk-text-grey-inactive"*/}
                {/*    }`}*/}
                {/*  >*/}
                {/*    {eventSummary && eventSummary.location.detail*/}
                {/*      ? eventSummary.location.detail*/}
                {/*      : "None"}*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className="tbk-flex tbk-flex-col tbk-justify-evenly md:tbk-flex-row">
                  <div className="with-tooltip tbk-relative tbk-mb-2 tbk-grow md:tbk-mr-2 md:tbk-mb-0">
                    <Button
                      ref={copyButtonRef}
                      variant="secondary"
                      size={"md"}
                      endIcon={<CopyIcon />}
                      className="tbk-w-full"
                      onClick={handleCopyAddressToClipboard}
                    >
                      Copy address
                    </Button>
                    <TBKTooltip
                      element={copyButtonRef.current}
                      adjust
                      inside
                      placement="top"
                      isShow={isCopyTooltipShow}
                      onClick={hideCopyTooltip}
                    >
                      Copied!
                    </TBKTooltip>
                  </div>

                  <Button
                    variant="secondary"
                    size={"md"}
                    className="tbk-grow"
                    onClick={handleOpenInMaps}
                  >
                    Open in Maps
                  </Button>
                </div>
              </div>
            </div>

            <div className="tbk-relative tbk-overflow-hidden tbk-rounded-2xl lg:tbk-h-auto lg:tbk-bg-none">
              <div
                className={`media-slider no-gradient tbk-h-92 md:tbk-h-[470px] ${
                  !partnerMedia || partnerMedia.length <= 1 ? "no-media" : ""
                } ${
                  true ? "tbk-justify-center" : ""
                } lg:tbk-w-108_ tbk-relative tbk-flex tbk-h-full tbk-w-full tbk-flex-col tbk-overflow-hidden lg:tbk-m-0 lg:tbk-h-108 lg:tbk-rounded-2xl`}
              >
                {slickInitialised &&
                partnerMedia &&
                // eventSummary && eventSummary.photos &&
                // eventSummary.photos.length > 1 ? (
                partnerMedia.length >= 1 ? (
                  <Slider
                    className="coach-media-carousel"
                    dots={true}
                    dotsClass={"slick-dots"}
                    arrows={clientWidth() > theme.responsive.breakpoints.lg}
                    autoplay={autoPlay}
                    autoplaySpeed={4000}
                    pauseOnFocus
                    pauseOnDotsHover
                    pauseOnHover
                    infinite={true}
                    speed={500}
                    slidesToShow={1}
                    slidesToScroll={1}
                    initialSlide={0}
                    responsive={sliderResponsiveSettings}
                    nextArrow={<SliderNextArrow className="" />}
                    prevArrow={<SliderPrevArrow className="" />}
                    onSwipe={handleSlideSwipe}
                  >
                    {partnerMedia.map((val, index) => (
                      <div
                        id={`slide-${index}`}
                        className="slide partner-review-item _tbk-pl-2.5 _tbk-pr-2.5"
                        key={index}
                        onClick={() => openGalleryCarouselModal(index)}
                      >
                        <div className="content slide-bg tbk-h-full tbk-w-full">
                          <div
                            className="tb-image-container tbk-relative tbk-h-full tbk-overflow-hidden tbk-pt-100 lg:tbk-pt-full"
                            style={
                              {
                                // paddingTop: "100%",
                              }
                            }
                          >
                            <img
                              className="tbk-absolute tbk-top-0 tbk-h-full tbk-w-full tbk-object-cover lg:tbk-rounded-2xl"
                              itemProp="image"
                              src={val.url}
                              alt={`Past photo for ${
                                eventSummary && eventSummary.name
                              } event`}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : eventSummary &&
                  eventSummary.photos &&
                  eventSummary.photos.length ? (
                  <div
                    className="tb-image-container tbk-relative tbk-overflow-hidden tbk-pt-100 lg:tbk-pt-full"
                    style={
                      {
                        // paddingTop: "100%",
                      }
                    }
                  >
                    <img
                      className="tbk-absolute tbk-top-0 tbk-h-full tbk-w-full tbk-object-cover lg:tbk-rounded-2xl"
                      itemProp="image"
                      src={_partnerMedia[0].photo}
                      alt={`Past photo for ${
                        eventSummary && eventSummary.name
                      } event`}
                    />
                  </div>
                ) : (
                  !eventSummary && (
                    <div className="tbk-py-5 sm:tbk-mt-[10px]">
                      <Lottie
                        options={defaultOptions}
                        height={
                          clientWidth() < theme.responsive.breakpoints.sm
                            ? 116
                            : 112
                        }
                        width={
                          clientWidth() < theme.responsive.breakpoints.sm
                            ? 116
                            : 112
                        }
                      />
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*<div className="tbk-container tbk-mx-auto tbk-px-2 lg:tbk-px-8">
        <hr />
      </div>*/}

      {/*<div className="tbk-flex tbk-flex-col tbk-items-center tbk-justify-center tbk-bg-grey-light tbk-pt-4 tbk-pb-4 lg:tbk-pb-7 lg:tbk-pt-9">
        <div className="tbk-container tbk-px-2 lg:tbk-px-8">
          <TitleWithSeparator
            textAlign={
              clientWidth() > theme.responsive.breakpoints.lg
                ? "left"
                : "center"
            }
            className="tbk-mb-3"
            titleClass="tbk-text-center tbk-bg-grey-light tbk-text-blue-grey tbk-text-h3-subtitle lg:tbk-text-title-bold"
            separatorClass="tbk-border-blue-grey-light"
          >
            More Classes
          </TitleWithSeparator>
          <div className="tbk-mb-6 ">
            <UpcomingExperiencesSlider
              showArrows={clientWidth() > theme.responsive.breakpoints.lg}
              className="tbk-pb-3"
              itemComponent={EventCard}
              itemProps={{
                to: !isUserLoggedIn &&
                  false && {
                    pathname: `/become-a-member`,
                    search: `?return_to=${encodeURIComponent(
                      "/checkout?membershipId=1"
                    )}`,
                    state: { from: location.pathname },
                  },
                imgClassName: "tbk-h-48 lg:tbk-h-75",
                showRsvpCta: true,
                isUserLoggedIn: isUserLoggedIn,
                onRsvpCtaClick: () => window.scrollTo(0, 0),
              }}
              futureEvents={moreClasses}
            />
          </div>
        </div>
      </div>*/}

      <div className="tbk-flex tbk-justify-center tbk-bg-grey-light tbk-pt-4 tbk-pb-7">
        <Button
          className="tbk-w-32 tbk-text-primary"
          variant="secondary"
          size={"md"}
          startIcon={<ArrowLeftIcon className="tbk-tex-primary" />}
          // onClick={() => history.goBack()}
          onClick={() =>
            history.push(
              `/events/${
                eventSummary && eventSummary.status === "COMPLETED"
                  ? "previous"
                  : "upcoming"
              }`
            )
          }
        >
          Back
        </Button>
      </div>

      {(customerMembershipLoaded || !user) &&
      eventSummary &&
      eventSummary.status !== "COMPLETED" &&
      /*!soldOut*/ true ? (
        <div className="tbk-p-2_ tbk-sticky tbk-bottom-0 tbk-z-10 tbk-rounded-t-2xl tbk-border-t tbk-border-blue-grey-light tbk-bg-basic-white tbk-shadow-trube lg:tbk-hidden">
          {eventSummary.joined ? (
            <div className="tbk-py-1 tbk-px-2 tbk-text-center">
              <div className="tbk-items-top tbk-text-main-linked tbk-mb-0.5 tbk-inline-flex tbk-max-w-full tbk-text-primary">
                <MapMarkerIcon className="tbk-shrink-0" />

                <div className="tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap">
                  {eventSummary && eventSummary.location.address}
                  {eventSummary && eventSummary.location.gymName ? ")" : ""}
                </div>
              </div>
              <div className="tbk-text-title-medium tbk-mb-0.5 tbk-text-green">
                You're Confirmed
              </div>
              <div className="tbk-text-secondary tbk-text-primary">
                {formattedDate[0]}, {formattedDate[1]}
              </div>
            </div>
          ) : eventSummary.status !== "UPCOMING_FULL" &&
            eventSummary.status !== "STARTED" &&
            !soldOut ? (
            <div className="tbk-py-2 tbk-px-2 tbk-text-center">
              <div className="tbk-items-top tbk-text-main-linked tbk-mb-1 tbk-inline-flex tbk-max-w-full tbk-text-blue-grey">
                <MapMarkerIcon className="tbk-shrink-0" />

                <div className="tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap">
                  {eventSummary && eventSummary.location.address}
                  {eventSummary && eventSummary.location.gymName ? ")" : ""}
                </div>
              </div>
              <Button
                // size={"md"}
                className="tbk-mb-2 tbk-w-full tbk-pl-5 tbk-pr-5 lg:tbk-mt-0 lg:tbk-mb-0"
                endIcon={<ArrowRightIcon className="tbk-ml-0.5" />}
                onClick={handleRsvpEvent}
              >
                {rsvpCtaLabel}
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}

      {region == "US" ? <AppBanner /> : <AppBannerUK />}
      <Footer regionSelect={false} className="tbk-relative" />

      <Modal
        isOpen={isGalleryCarouselModalOpen}
        // onAfterOpen={this.afterOpenModal}
        onRequestClose={closeGalleryCarouselModal.bind(null, true)}
        style={modalStyles.galleryCarouselDefault}
        contentLabel="Gallery Carousel"
      >
        {/*<Link role='button' onClick={this.closeDateTimeSelectorModal}><Icon name='close' className='tb-pd-0' width='32px' height='32px' /></Link>*/}
        <div
          role="button"
          className="tbk-absolute tbk-top-2 tbk-right-2 tbk-z-10 tbk-p-1"
          onClick={closeGalleryCarouselModal}
        >
          <CloseIcon className="tbk-p-0 tbk-text-basic-white" />
        </div>
        <div className="modal-gallery-carousel u-d-flex_ u-flex-column_ tbk-h-full">
          <MediaBlock media={partnerMedia} initialSlide={galleryInitialSlide} />
        </div>
      </Modal>
      <Modal
        appElement={/*__CLIENT__ && */ document.getElementById("#app")}
        isOpen={isCancelRsvpModalOpen}
        onRequestClose={closeCancelRsvpModal}
        style={defaultCustomStyle}
        contentLabel="Cancel RSVP"
      >
        <div className="modal-cancel-rsvp tbk-rounded-2xl tbk-bg-basic-white">
          <h3
            className={`tbk-text-h3-subtitle tbk-mt-0 tbk-mb-2 tbk-text-center tbk-text-blue-dark`}
          >
            Sorry to miss you!
          </h3>
          <p className="tbk-text-main tbk-mb-4 tbk-text-center tbk-text-blue-grey">
            Tap here to cancel your RSVP and free up your spot for someone else.
            We hope to see you at the next one
          </p>
          <Button
            variant="secondary"
            disabled={isFetching}
            showLoader={isFetching}
            className="tbk-mb-2 tbk-w-full"
            onClick={handleCancelRsvp}
          >
            Cancel RSVP
          </Button>
          <Button
            variant="secondary"
            disabled={isFetching}
            className="tbk-w-full"
            onClick={closeCancelRsvpModal}
          >
            Keep RSVP
          </Button>
        </div>
      </Modal>

      <Modal
        appElement={/*__CLIENT__ && */ document.getElementById("#app")}
        isOpen={isInfoModalOpen}
        // onAfterOpen={afterOpenInfoModal}
        onRequestClose={closeInfoModal}
        style={
          clientWidth() < theme.responsive.breakpoints.sm
            ? modalStyles.infoMobile
            : modalStyles.info
        }
        contentLabel="Info Modal"
      >
        <div className="modal-info tbk-flex tbk-flex-col tbk-items-center">
          <button
            onClick={closeInfoModal}
            className="tbk-absolute tbk-top-2 tbk-right-2 tbk-z-10 tbk-hidden tbk-text-coral"
          >
            <CloseIcon />
          </button>
          <h3 className="tbk-text-title-bold tbk-mt-0 tbk-mb-1 tbk-text-center tbk-text-grey-main">
            {infoModalTitle}
          </h3>
          <p className="tbk-text-main tbk-mb-4 tbk-max-w-full tbk-text-center tbk-text-grey-main">
            {infoModalMsg}
          </p>
          {error ? (
            <BlockerIcon size={64} className="tbk-mb-4 tbk-text-green" />
          ) : (
            <CheckNiceIcon size={64} className="tbk-mb-4 tbk-text-green" />
          )}
          <Button className="tbk-w-full" onClick={closeInfoModal}>
            Ok
          </Button>
        </div>
      </Modal>
      <ShareModal
        isOpen={isShareModalOpen}
        modalTitle="Share the link"
        modalText={`Share the link to ${
          eventSummary && eventSummary.name
        } so that your friend can experience the best fitness and well-being journey like you have.`}
        shareTitle={`Book a session with ${
          eventSummary && eventSummary.name
        } | TruBe`}
        shareText="Experience the best fitness and well-being journey!"
        shareLabel={`Link to ${eventSummary && eventSummary.name} event:`}
        shareInput={`https://trubeapp.com/${
          region === "GB" ? "" : "us/"
        }events/${eventSummary && eventSummary.id}`}
        shareUrl={`https://trubeapp.com/${region === "GB" ? "" : "us/"}events/${
          eventSummary && eventSummary.id
        }`}
        copyFeedbackText="The link has been copied!"
        onClose={closeShareModal}
      />
    </>
  );
}

const formatDate = (eventSummary, region) => {
  if (!eventSummary) {
    return;
  }

  let startDate = moment.utc(eventSummary.start).tz(getTz(region));

  return [startDate.format("dddd"), startDate.format("MMMM Do")];
};
const formatTime = (eventSummary, region, amPmShort) => {
  if (!eventSummary) {
    return;
  }

  let startDate = moment.utc(eventSummary.start).tz(getTz(region));
  let endDate = moment.utc(eventSummary.finish).tz(getTz(region));

  let formattedStartTime = startDate.format("h:mm").replace(":00", "");
  let formattedEndTime = endDate.format("h:mm").replace(":00", "");
  let formattedStartTimeAmPm = startDate.format("A");
  let formattedEndTimeAmPm = endDate.format("A");

  return amPmShort
    ? `${formattedStartTime}–${formattedEndTime} ${formattedEndTimeAmPm}`
    : `${formattedStartTime} ${formattedStartTimeAmPm} – ${formattedEndTime} ${formattedEndTimeAmPm}`;
};

export const formatEventDates = (eventSummary, region) => {
  if (!eventSummary) {
    return;
  }

  let startDate = moment.utc(eventSummary.start).tz(getTz(region));
  let endDate = moment.utc(eventSummary.finish).tz(getTz(region));

  let formattedStartTime = startDate.format("h:mm A").replace(":00", "");
  let formattedEndTime = endDate.format("h:mm A").replace(":00", "");

  const formattedDate = formatDate(eventSummary, region);
  return [
    formattedDate ? `${formattedDate[0]}, ${formattedDate[1]}` : "",
    formatTime(eventSummary, region),
  ];
};

const getSingleTicketItem = (membershipItems) => {
  if (!membershipItems || !membershipItems.length) {
    return;
  }

  return membershipItems.find(
    (val) =>
      val.metadata.type === "EVENT" &&
      val.metadata.isMembershipRequired == false
  );
};

const adaptCityName = (cityName) => {
  return cityName
    ? cityName === "LOS_ANGELES"
      ? "Los Angeles"
      : cityName === "SAN_DIEGO"
      ? "San Diego"
      : cityName === "LONDON"
      ? "London"
      : "All"
    : "All";
};
